/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 监管动态搜索
 */

import commonStyles  from '../../common/common.scss';
import React, { PureComponent } from 'react';
import { Form, Select } from 'antd';
import cns from 'classnames';
import { debounce } from '../../../../../utils/debounce';
const FormItem = Form.Item;
const Option = Select.Option;

class SearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.onSubmit();
    }

    componentWillUnmount() {
        this.syncSearch.cancel();
    }

    syncSearch = debounce(() => {
        this.onSubmit();
    }, 300);

    onSubmit = (e) => {
        e && e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                onSearch && onSearch(values);
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className={cns('search-bar', commonStyles.searchBar)}>
                <Form hideRequiredMark layout="inline" className="align-c" onSubmit={this.onSubmit}>
                    <FormItem label="最新监管公告">
                        {getFieldDecorator('dateType', {
                            initialValue: '1'
                        })(
                            <Select size="default" onChange={this.syncSearch}>
                                <Option value="1">近三天</Option>
                                <Option value="2">近一周</Option>
                                <Option value="3">近半个月</Option>
                            </Select>
                        )}
                    </FormItem>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(SearchForm));



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/state/newest/SearchForm.jsx